module.exports = __webpack_public_path__ + "img/packages.aae80090.svg";